import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as ArrowIcon } from '../../../images/ArrowIcon.svg';
import { ReactComponent as DropdownIconGrey } from '../../../images/DropdownIcon.svg';
import styles from './Table2.module.css';
import CircularProgress from '@mui/material/CircularProgress';
import InnerTable from './InnerTable';
import { Transaction, TransactionItem } from '../../../services/TransactionsService';
import { GradesDTO } from '../../../dto/GradesDTO';

 

interface TableRowData {
    [key: string]: string | number | { Book: string; Quantity: number; "Price($)": number; }[];
}

interface TableProps {
    columns: string[];
    Innercolumns: string[];
    data: TableRowData[];
    onView?: (index: number) => void;
    loading: boolean;
    sortDirection: 'asc' | 'desc';
    handleSort: (column: string) => void;
    sortColumn: string | null;
    books: Transaction[];
    handleDownloadReceipt: (orderId: string) => void;
}

const PurchaseHistoryTable: React.FC<TableProps> = ({ columns, data, books, onView, sortColumn, sortDirection, loading, handleSort, Innercolumns, handleDownloadReceipt }) => {
 
    const [expandedRow, setExpandedRow] = useState<number | null>(null);
    const dropdownRef = useRef<HTMLDivElement | null>(null);
  
    const toggleExpandRow = (index: number) => {
      setExpandedRow(prevIndex => (prevIndex === index ? null : index));
    };

    console.log('books;::::',books)

    return (
        <div className={styles.container}>
      <div className={styles.table}>
        {/* Table Header */}
        <div className={styles.tableHeader} style={{ gridTemplateColumns: `repeat(${columns.length}, 1fr)` }}>
          {columns.map((column, index) => (
            <div key={index} className={styles.tableHeaderCell} onClick={() => handleSort(column)}>
              {column !== 'Book Cover' && column !== 'Logo' && column !== 'Active Icon' && column !== 'Default Icon' && (
                <ArrowIcon
                  className={`${styles.arrowIcon} ${sortColumn === column ? (sortDirection === 'asc' ? styles.asc : styles.desc) : ''}`}
                />
              )}
              {column}
            </div>
          ))}
        </div>

        {/* Table Body */}
        <div className={styles.tableBody}>
          {loading ? (
            <div className="text-center mt-8">
              <CircularProgress />
            </div>
          ) : data.length > 0 && Array.isArray(data) ? (
            data.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                {/* Row */}
                <div
                  className={`${styles.tableRow} ${expandedRow === rowIndex ? styles.expandedRow : ''}`}
                  onClick={() => toggleExpandRow(rowIndex)}
                  style={{ gridTemplateColumns: `repeat(${columns.length}, 1fr)` }}
                >
                  {columns.map((column, colIndex) => (
                    <div key={colIndex} className={styles.tableCell}>
                      {['Total Price'].includes(column) ? (
                        <p>{"$" + row[column] || <i>null</i>}</p>
                      ) : colIndex !== columns.length - 1 ? (
                        <p title={String(row[column] || 'null')} className={styles.spanStyle}>
                          {String(row[column] || 'null')}
                        </p>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: '32px' }}>
                          <button className="bg-[#00726B] rounded-[6px] text-white font-bold text-[12px] py-[7px] px-[14px]" onClick={(e) => {e.stopPropagation(); handleDownloadReceipt(books[rowIndex]._id)}} >
                            Download
                          </button>
                          <div className="relative">
                            <div ref={dropdownRef} className={styles.dropdownIcon}>
                              <DropdownIconGrey
                                className={
                                  `${styles.detailsIcon} ${expandedRow === rowIndex ? styles.rotatedOpen : styles.rotated}`
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Expanded Content */}
                {expandedRow === rowIndex && (
                 <InnerTable
                    columns={Innercolumns}
                    data={books[rowIndex]?.items.map((item: TransactionItem) => ({
                      "Book": item.book.bookCoverUrl || '',
                      "BookTitle": item.book.bookTitle || 'N/A',
                      "Quantity": item.quantity,
                      'Grades':item.book?.type==='university book'?'Book':item.book?.language==='Arabic'?item.book?.grades?.map((grade: GradesDTO) => grade.arName).join(', '):item.book?.grades?.map((grade: GradesDTO) => grade.engName).join(', '),
                      "Price($)": item.purchasedPrice,
                      "AccessCodes":item.batchId.accessCodes
                    })) || []}          
                    handleSort={handleSort}
                    sortColumn={sortColumn || ''}
                    sortDirection={sortDirection}
                    loading={false}
                    dropdownRef={dropdownRef}
                  />
                )}
              </React.Fragment>
            ))
          ) : (
            <div className="text-center mt-8">
              <h1>No Data Found</h1>
            </div>
          )}
        </div>
      </div>
        </div>
    );
};

export default PurchaseHistoryTable;
